import FeedbackContext from 'contexts/FeedbackContext';
import { useContext } from 'react';

const useFeedback = () => useContext(FeedbackContext);

export default useFeedback;